<app-header></app-header>
<ion-content>
  <div
    class="invoices-content gray-content-bg"
    #mainDivScroll
    cdkVirtualScrollingElement
    *ngIf="vm$ | async; let vm"
  >
    <div class="main-header">
      <app-header-filters
        [isTouch]="(isTouch$ | async)"
        [breadcrumbs]="vm.breadcrumbs"
        [service]="paymentActivityService"
        [filters]="vm.filters"
        [showQuickDateFilterOption]="true"
        [showResetFilterOption]="true"
        [isLoading]="isInitialLoading"
        [platformType]="platformService?.platformType"
        [filterVm$]="vm$"
        [title]="title"
        [isWindows]="platformService?.isWindows()"
        [quickFilters]="quickFilters"
        [modalType]="ModalType.paymentActivity"
        [defaultDateFilterId]="PaymentFilterIds.paymentDate"
        [showShare]="!vm.isLoadingPayments && vm.payments.length > 0"
        (downloadAllEmitter)="downloadAllPayments()"
        (printAllEmitter)="printAllPayments()"
        (resetFiltersEmitter)="resetFilters()"
        (toggleStatusEmitter)="paymentActivityService.setFilter($event)"
        (shareEmitter)="shareAllPayments()"
        (shareDownloadEmitter)="openShareDownload($event)"
      ></app-header-filters>
    </div>
    <div class="margin-bottom">
      <ion-grid>
        <div class="initial-loading" *ngIf="isInitialLoading">
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
        </div>
        <ng-container *ngIf="!isInitialLoading && vm.payments.length > 0">
          <app-table-header
            *ngIf="platformService?.platformType === PlatformEnum.desktop"
            [dataColumns]="[
        {
          size: '2',
          dataCyName: 'reference-num',
          sortField: SortFields.REFERENCE_NUMBER,
          sortDirectionByDefault: SortDirection.ASC,
          label: paymentRowText.referenceNumber
        },
        {
          size: '2',
          dataCyName: 'payment-method',
          sortField: SortFields.PAYMENT_METHOD,
          sortDirectionByDefault: SortDirection.ASC,
          label: paymentRowText.paymentMethod
        },
        {
          size: '1.5',
          dataCyName: 'payment-date',
          sortField: SortFields.PAYMENT_DATE,
          label:  paymentRowText.paymentDate
        },
        {
          size: '1.3',
          dataCyName: 'items',
          sortField: SortFields.ITEMS,
          label: paymentRowText.items
        },
        {
          size: '1.5',
          dataCyName: 'customers',
          sortField: SortFields.CUSTOMERS,
          label:  paymentRowText.customers
        },
        {
          size: '1.7',
          dataCyName: 'payment-amount',
          sortField: SortFields.PAYMENT_AMOUNT,
          label:  paymentRowText.paymentAmount
        },
        {
          size: '1.5',
          dataCyName: 'status',
          sortField: SortFields.STATUS,
          sortDirectionByDefault: SortDirection.ASC,
          label:  paymentRowText.status
        },
        {
          size: 'auto',
          dataCyName: 'blank',
          label:  '',
          isNotSortable: true
        },
      ]"
            [sortField]="sortField"
            (clickEmit)="handleSort($event)"
            [sortDirection]="sortDirection"
          ></app-table-header>
          <cdk-virtual-scroll-viewport
            *ngIf="platformService?.platformType === PlatformEnum.desktop"
            itemSize="76"
            (scrolledIndexChange)="scrolledIndexChange($event, vm.pageNum, vm.hasNextPage, vm.isLoadingActivity)"
          >
            <app-payment-row-desktop
              *cdkVirtualFor="
              let payment of vm.payments;
              let i = index;
              trackBy: trackByIdx
            "
              [vm]="payment"
              [browserDimensions]="browserDimensions"
              [isMobile]="isMobile"
              [isTouch]="(isTouch$ | async)"
              [canCancelPayment]="canCancel && payment.status === PendingStatus"
              (moreOptionsClickEmitter)="openMoreOptions($event)"
              (referenceNumClickEmitter)="openViewDetailsModal($event)"
            ></app-payment-row-desktop>
          </cdk-virtual-scroll-viewport>
          <cdk-virtual-scroll-viewport
            *ngIf="platformService?.platformType === PlatformEnum.tablet"
            itemSize="126"
            (scrolledIndexChange)="scrolledIndexChange($event, vm.pageNum, vm.hasNextPage,vm.isLoadingActivity)"
          >
            <app-payment-row-tablet
              *cdkVirtualFor="
              let payment of vm.payments;
              let i = index;
              trackBy: trackByIdx
            "
              [vm]="payment"
              [browserDimensions]="browserDimensions"
              [isMobile]="isMobile"
              [isTouch]="(isTouch$ | async)"
              [paymentRowText]="paymentRowText"
              [canCancelPayment]="canCancel && payment.status === PendingStatus"
              (moreOptionsClickEmitter)="openMoreOptions($event)"
              (referenceNumClickEmitter)="openViewDetailsModal($event)"
            ></app-payment-row-tablet>
          </cdk-virtual-scroll-viewport>
          <cdk-virtual-scroll-viewport
            *ngIf="platformService?.platformType === PlatformEnum.mobile"
            itemSize="156"
            (scrolledIndexChange)="scrolledIndexChange($event, vm.pageNum, vm.hasNextPage, vm.isLoadingActivity)"
          >
            <app-payment-row-mobile
              *cdkVirtualFor="
              let payment of vm.payments;
              let i = index;
              trackBy: trackByIdx
            "
              [vm]="payment"
              [browserDimensions]="browserDimensions"
              [isMobile]="isMobile"
              [isTouch]="(isTouch$ | async)"
              [paymentRowText]="paymentRowText"
              [canCancelPayment]="canCancel && payment.status === PendingStatus"
              (moreOptionsClickEmitter)="openMoreOptions($event)"
              (referenceNumClickEmitter)="openViewDetailsModal($event)"
            ></app-payment-row-mobile>
          </cdk-virtual-scroll-viewport>
        </ng-container>
        <div class="load-more">
          <ng-container *ngIf="vm.isLoadingActivity && vm.pageNum > 0">
            <ion-skeleton-text class="item" animated></ion-skeleton-text>
            <ion-skeleton-text class="item" animated></ion-skeleton-text>
            <ion-skeleton-text class="item" animated></ion-skeleton-text>
            <ion-skeleton-text class="item" animated></ion-skeleton-text>
          </ng-container>
        </div>
      </ion-grid>

      <app-empty-states
        *ngIf="!isInitialLoading && !vm.isLoadingPayments && vm.payments.length <= 0"
        [title]="'i18n.payments.paymentActivity.thereAreNoPayments' | translate"
        [buttons]="[{
        text: 'i18n.payments.paymentActivity.backToPaymentCenter' | translate,
        action: goBackToPaymentCenter,
        color: 'usf-fill-green-button'
        }]"
      ></app-empty-states>
    </div>

    <app-footer></app-footer>
  </div>
</ion-content>

<div *ngIf="vm$ | async; let vm" class="payment-activity-actions">
  <app-top-button
    [mainScroll]="mainScroll"
    [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
  ></app-top-button>
  <div class="help-button">
    <img
      data-cy="payment-activity-help-button"
      src="assets/icon/custom-help-tooltip.svg"
      (click)="openHelpModal()"
      alt="help image"
    />
  </div>
</div>
